const defaultLang = "en"
let language = defaultLang;
export {language};
export default defaultLang;